/**
 * VocalLayout — Layout minimaliste pour /vocal.
 *
 * Barre unifiée flottante (Option A) : retour Accueil + sélecteur d'onglets
 * (Saisie / Tuto / Scénarios) dans une seule pilule glass centrée, persistante
 * sur les 3 sous-routes — un seul élément positionné, donc aucune collision
 * flottante (corrige le recouvrement du retour). Le contenu de l'onglet est rendu
 * via <Outlet /> (sous-routes imbriquées, React Router v6 — cohérent avec
 * AppShell). PersonaProvider enveloppe le tout : il reste monté entre onglets
 * (pas de ré-init TTS).
 */

import { Link, NavLink, Outlet } from 'react-router-dom';
import { PersonaProvider } from '@/shared/contexts/PersonaContext';
import './VocalLayout.css';

const TABS = [
  { to: '/vocal', label: 'Saisie', icon: 'bi-mic', end: true },
  { to: '/vocal/tuto', label: 'Tuto', icon: 'bi-info-circle', end: false },
  { to: '/vocal/scenarios', label: 'Scénarios', icon: 'bi-list-check', end: false },
  // Lien sortant vers le viewer DPI JSON (rendu sous AppShell, hors zone /vocal).
  { to: '/dpi', label: 'DPI', icon: 'bi-activity', end: false },
];

export function VocalLayout() {
  return (
    <PersonaProvider>
      <div className="min-vh-100 position-relative">
        <div className="vocal-topbar">
          <Link to="/home" className="vocal-tab vocal-tab-back">
            <i className="bi bi-arrow-left" />
            <span>Accueil</span>
          </Link>
          <span className="vocal-sep" aria-hidden="true" />
          <nav className="vocal-nav" aria-label="Sections /vocal">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                className={({ isActive }) => `vocal-tab${isActive ? ' is-active' : ''}`}
              >
                <i className={`bi ${t.icon}`} />
                <span>{t.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        <main style={{ height: '100vh', overflow: 'hidden' }}>
          <Outlet />
        </main>
      </div>
    </PersonaProvider>
  );
}
